export default __webpack_public_path__ + "static/media/Bullrush_Logo.df57f0b4.png";